import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent, BreadcrumbItem } from '../../shared/components/breadcrumb/breadcrumb.component';
import { NgApexchartsModule } from "ng-apexcharts";
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexYAxis,
  ApexPlotOptions,
  ApexDataLabels,
  ApexFill,
  ApexNonAxisChartSeries,
  ApexLegend,
  ApexResponsive,
  ApexTooltip
} from 'ng-apexcharts'

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  colors: string[];
  fill: ApexFill;
  plotOptions: ApexPlotOptions;
  responsive: ApexResponsive[];
  xaxis: ApexXAxis;
};

export type DonutChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  colors: string[];
  legend: ApexLegend;
  dataLabels: ApexDataLabels;
  responsive: ApexResponsive[];
  plotOptions: ApexPlotOptions;
};

export type ChartOptionsMulti = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  stroke: any;
  colors: string[];
  fill: ApexFill;
  responsive: ApexResponsive[];
};


@Component({
  selector: 'app-home',
  imports: [CommonModule,
    NgApexchartsModule,
    BreadcrumbComponent,],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home {

  protected breadcrumbItems: BreadcrumbItem[] = [
    { label: 'HOME', active: false, url: '/home' }
  ];

  public selectedTab: number = 1;
  public chartOptionsIngresos: ChartOptions = {
    series: [
      {
        name: "basic",
        data: [400, 430, 448]
      }
    ],
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        dataLabels: {
          position: "center"
        }
      }
    },
    colors: ['#174D9C', '#00ADEF', '#5B5FA5', '#2670E0', '#9427AF'],
    fill: {
      colors: ['#174D9C', '#00ADEF', '#5B5FA5', '#2670E0', '#9427AF']
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number) => {
        return `$${val.toLocaleString('es-CL')}`;
      },
      style: {
        colors: ["#fff"],
        fontSize: "14px",
        fontWeight: "bold"
      }
    },
    xaxis: {
      categories: [
        "South Korea",
        "Canada",
        "United Kingdom"
      ]
    },
    responsive: []
  };

  public chartOptionsGatos: ChartOptions = {
    series: [
      {
        name: "basic",
        data: [400, 430, 448]
      }
    ],
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        dataLabels: {
          position: "center"
        }
      }
    },
    colors: ['#174D9C', '#00ADEF', '#5B5FA5', '#2670E0', '#9427AF'],
    fill: {
      colors: ['#174D9C', '#00ADEF', '#5B5FA5', '#2670E0', '#9427AF']
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number) => {
        return `$${val.toLocaleString('es-CL')}`;
      },
      style: {
        colors: ["#fff"],
        fontSize: "14px",
        fontWeight: "bold"
      }
    },
    xaxis: {
      categories: [
        "South Korea",
        "Canada",
        "United Kingdom"
      ]
    },
    responsive: []
  };

  public chartOptionsDesviacion: ChartOptions = {
    series: [
      {
        name: "basic",
        data: [400, 430, 448]
      }
    ],
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        dataLabels: {
          position: "center"
        }
      }
    },
    colors: ['#174D9C', '#00ADEF', '#5B5FA5', '#2670E0', '#9427AF'],
    fill: {
      colors: ['#174D9C', '#00ADEF', '#5B5FA5', '#2670E0', '#9427AF']
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number) => {
        return `$${val.toLocaleString('es-CL')}`;
      },
      style: {
        colors: ["#fff"],
        fontSize: "14px",
        fontWeight: "bold"
      }
    },
    xaxis: {
      categories: [
        "South Korea",
        "Canada",
        "United Kingdom"
      ]
    },
    responsive: []
  };

  public chartOptionsDistribucionCostoMargen: ChartOptions = {
    series: [
      {
        name: "basic",
        data: [400, 430, 448]
      }
    ],
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        distributed: true,
        dataLabels: {
          position: "center"
        }
      }
    },
    colors: ['#174D9C', '#00ADEF', '#5B5FA5', '#2670E0', '#9427AF'],
    fill: {
      colors: ['#174D9C', '#00ADEF', '#5B5FA5', '#2670E0', '#9427AF']
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number) => {
        return `$${val.toLocaleString('es-CL')}`;
      },
      style: {
        colors: ["#fff"],
        fontSize: "14px",
        fontWeight: "bold"
      }
    },
    xaxis: {
      categories: [
        "South Korea",
        "Canada",
        "United Kingdom"
      ]
    },
    responsive: []
  };

  public donutChartOptions: DonutChartOptions = {
    series: [12,13.14],
    chart: {
      type: 'donut',
      height: 320,
      fontFamily: 'Nunito, sans-serif'
    },
    labels: [
      "Industria1","Industria2","Industria3",
    ],
    colors: ['#174D9C', '#00ADEF', '#5B5FA5', '#2670E0', '#9427AF'],
    dataLabels: {
      enabled: false
    },
    legend: {
      fontFamily: 'Nunito, sans-serif',
      show: true,
      position: 'right',
      fontSize: '14px',
      itemMargin: {
        vertical: 8
      }
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: { show: false },
            total: {
              show: true,
              formatter: (w: any) => {
                return w.globals.seriesTotals.reduce(
                  (a: number, b: number) => a + b,
                  0
                );
              }
            }
          }
        }
      }
    },
    responsive: []
  };

  public chartOptionsEjecuccionProyectosMensaluales: ChartOptionsMulti = {
    series: [
      {
        name: "serie1",
        data: [400, 430, 448]
      },
      {
        name: "serie2",
        data: [400, 430, 448]
      },
      {
        name: "serie3",
        data: [400, 430, 448]
      }
    ],
    chart: {
      type: "bar",
      height: 430,
      toolbar: {
        show: false
      },

    },
    plotOptions: {
      bar: {
        horizontal: false,
        distributed: false,
        dataLabels: {
          position: "top"
        }

      }
    },
    colors: ['#174D9C', '#00ADEF', '#5B5FA5', '#2670E0', '#9427AF'],
    fill: {
      colors: ['#174D9C', '#00ADEF', '#5B5FA5', '#2670E0', '#9427AF']
    },
    dataLabels: {
      enabled: true,
      offsetX: -6,
      style: {
        colors: ["#fff"],
        fontSize: "14px",
        fontWeight: "bold"
      }
    },
    stroke: {
      show: true,
      width: 3,
      colors: ["#fff"]
    },
    xaxis: {
      categories: [
        "Enero",
        "Febrero",
        "Marzo"
      ]
    },
    responsive: []
  };



}
